import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SITE } from "../data/site";
import { MaskedLines, Reveal } from "../components/Reveal";

// SCENE 12: the orange moment — conversion as a statement, not a form block.
export function ConvertScene() {
  return (
    <section className="relative overflow-hidden bg-dcc text-charcoal" aria-label="Request a free site survey">
      <div className="absolute inset-0 opacity-[0.07]" aria-hidden="true"
        style={{ backgroundImage: "linear-gradient(to right, #0A0A0A 1px, transparent 1px)", backgroundSize: "8.333% 100%" }} />
      <div className="container-x relative py-16 md:py-24">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-charcoal/70">10 / The first step costs nothing</p>
        </Reveal>
        <MaskedLines
          as="h2"
          lines={["SHOW US THE SYSTEM.", "WE'LL SHOW YOU", "THE PLAN."]}
          className="h-display mt-8 text-[11vw] leading-[0.95] text-charcoal sm:text-[8vw] lg:text-[5.5vw]"
        />
        <Reveal delay={0.2}>
          <p className="mt-10 max-w-lg text-base font-medium leading-relaxed text-charcoal/80 md:text-lg">
            A free technical survey makes the condition of your ducts, exhausts or drainage visible — photographed, graded and scoped before you commit to anything.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-12 flex flex-wrap gap-4">
            <Link to={SITE.cta.to} data-testid="convert-survey-cta" data-cursor="GO"
              className="inline-flex items-center gap-3 bg-charcoal px-8 py-4 font-display text-sm font-semibold uppercase tracking-widest text-white transition-transform duration-300 hover:-translate-y-0.5">
              {SITE.cta.label} <ArrowUpRight size={16} aria-hidden="true" />
            </Link>
            <a href={`tel:${SITE.contact.phone.replace(/\s/g, "")}`} data-testid="convert-call-cta"
              className="inline-flex items-center gap-3 border border-charcoal px-8 py-4 font-display text-sm font-semibold uppercase tracking-widest text-charcoal transition-colors duration-300 hover:bg-charcoal hover:text-white">
              Call {SITE.contact.phone}
            </a>
          </div>
        </Reveal>
        <Reveal delay={0.4}>
          <p className="mt-14 font-mono text-[11px] uppercase tracking-[0.3em] text-charcoal/60">
            {SITE.methodology.join(" → ")}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
